import type { LeaseActionProps } from '../../../models/Types';

function StartSigningExperience({ terminateActiveAction }: LeaseActionProps) {
  terminateActiveAction();
  return null;
}

export default StartSigningExperience;
